export {default as PrivateRoute} from './PrivateRoute';



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.tsx